import Snaker, { Options } from '../index'
import createWebClick from './webClick'
import { getElementVPath } from './utils'

interface VuePluginOptions extends Options {
  router: any
  webClick: boolean
}

export default {
  install(Vue: any, pluginOptions: VuePluginOptions) {
    const { router, webClick = false, ...options } = pluginOptions
    const snaker = new Snaker(options)
    const report = {
      binding: function(event: MouseEvent): void {},
      add(el: HTMLElement, value: string) {
        this.binding = function() {
          snaker.trackAsync('event', 'click', value)
        }
        el.addEventListener('click', this.binding)
      },
      remove(el: HTMLElement) {
        el.removeEventListener('click', this.binding)
      }
    }

    Vue.directive('sk', {
      bind(el: HTMLElement, binding: any) {
        report.add(el, binding.value)
      },
      unbind(el: HTMLElement) {
        report.remove(el)
      }
    })

    Vue.prototype.$snaker = snaker

    if (router) {
      router.afterEach((to: any, from: any) => {
        snaker.trackAsync('pageView', to.path, from.path)
      })
    }

    if (webClick) {
      const instance = createWebClick(snaker, function (ev: MouseEvent) {
        const el = ev.target as Element
        const vpath = getElementVPath(el)
        return {
          vpath
        }
      })
      instance.start()
    }
  }
}
